import { Controller } from '@hotwired/stimulus'
import debounce from 'debounce';

export default class extends Controller {
  static targets = ['name', 'subject', 'from', 'details', 'category', 'fromPreview', 'subjectPreview', 'namePreview', 'detailsPreview', 'categoryPreview']

  initialize() {
    this.updateDetails = debounce(this.updateDetails.bind(this), 50);
  }

  updateFrom() {
    this.fromPreviewTarget.innerText = this.fromTarget.value;
  }

  updateName() {
    this.namePreviewTarget.innerText = this.nameTarget.value;
  }

  updateSubject() {
    this.subjectPreviewTarget.innerText = this.subjectTarget.value;
  }

  updateDetails() {
    this.detailsPreviewTarget.innerHTML = this.detailsTarget.value;
  }

  updateCategory() {
    this.categoryPreviewTarget.innerText = this.categoryTarget.value;
  }
}
